(function () {
  'use strict';

  const CACHE = new Map();


  /* =========================================================
     BASIC HELPERS
     ========================================================= */

  function clean(value) {
    return String(value || '').trim();
  }


  function compare(valueA, valueB) {
    return clean(valueA).toLowerCase() ===
           clean(valueB).toLowerCase();
  }

  function compareDimension(
  dimension,
  valueA,
  valueB
) {

  /*
   * Widths may be written as:
   * 2mm
   * 2.0mm
   * 7mm
   * 7.0mm
   *
   * Treat those as the same width.
   */

  if (dimension === 'width') {

    const numberA =
      parseFloat(clean(valueA));

    const numberB =
      parseFloat(clean(valueB));

    if (
      !Number.isNaN(numberA) &&
      !Number.isNaN(numberB)
    ) {

      return (
        Math.abs(
          numberA - numberB
        ) < 0.0001
      );

    }

  }


  return compare(
    valueA,
    valueB
  );

}

  function unique(values) {

    const result = [];

    values.forEach(function (value) {

      const cleaned = clean(value);

      if (!cleaned) return;

      const alreadyExists =
        result.some(function (existing) {
          return compare(existing, cleaned);
        });

      if (!alreadyExists) {
        result.push(cleaned);
      }

    });

    return result;
  }


  function normaliseProduct(node) {

    return {

      id: node.id,

      handle: clean(node.handle),

      title: clean(node.title),

      url:
        clean(node.onlineStoreUrl) ||
        '/products/' + clean(node.handle),

available:
  node.availableForSale !== false,

price:
  Number(
    node.priceRange?.minVariantPrice?.amount || 0
  ),

currencyCode:
  clean(
    node.priceRange?.minVariantPrice?.currencyCode
  ) || 'AUD',

family:
  clean(node.ringFamily?.value),

      width:
        clean(node.ringWidth?.value),

      metal:
        clean(node.ringMetal?.value),

      finish:
        clean(node.ringFinish?.value),

      diamondType:
        clean(node.ringDiamondType?.value)

    };

  }


  function getCurrentSelection(picker) {

    return {

      width:
        clean(picker.dataset.ringWidth),

      metal:
        clean(picker.dataset.ringMetal),

      finish:
        clean(picker.dataset.ringFinish),

      diamondType:
        clean(picker.dataset.ringDiamondType)

    };

  }


  /* =========================================================
     SORTING
     ========================================================= */

  function sortWidths(values) {

    return values.sort(function (a, b) {

      const numberA = parseFloat(a);
      const numberB = parseFloat(b);

      if (
        !Number.isNaN(numberA) &&
        !Number.isNaN(numberB)
      ) {
        return numberA - numberB;
      }

      return a.localeCompare(b);

    });

  }


  const METAL_ORDER = [

    '9ct Yellow Gold',
    '9ct White Gold',
    '9ct Rose Gold',

    '14ct Yellow Gold',
    '14ct White Gold',
    '14ct Rose Gold',

    '18ct Yellow Gold',
    '18ct White Gold',
    '18ct Rose Gold',

    'Platinum'

  ];


  function sortMetals(values) {

    return values.sort(function (a, b) {

      const indexA =
        METAL_ORDER.findIndex(function (value) {
          return compare(value, a);
        });

      const indexB =
        METAL_ORDER.findIndex(function (value) {
          return compare(value, b);
        });


      const safeA =
        indexA === -1 ? 999 : indexA;

      const safeB =
        indexB === -1 ? 999 : indexB;


      if (safeA !== safeB) {
        return safeA - safeB;
      }

      return a.localeCompare(b);

    });

  }


  function sortFinishes(values) {

    const order = [
      'Polished',
      'High Polish',
      'High-Polish',
      'Brushed',
      'Matte',
      'Hammered'
    ];


    return values.sort(function (a, b) {

      const indexA =
        order.findIndex(function (value) {
          return compare(value, a);
        });

      const indexB =
        order.findIndex(function (value) {
          return compare(value, b);
        });


      return (
        (indexA === -1 ? 999 : indexA) -
        (indexB === -1 ? 999 : indexB)
      );

    });

  }


  function sortDiamondTypes(values) {

    const order = [
      'Lab',
      'Lab Grown',
      'Laboratory Grown',
      'Natural',
      'Mined'
    ];


    return values.sort(function (a, b) {

      const indexA =
        order.findIndex(function (value) {
          return compare(value, a);
        });

      const indexB =
        order.findIndex(function (value) {
          return compare(value, b);
        });


      return (
        (indexA === -1 ? 999 : indexA) -
        (indexB === -1 ? 999 : indexB)
      );

    });

  }


  /* =========================================================
     STOREFRONT API
     ========================================================= */

const FAMILY_QUERY = `
  query RCMJRingFamily(
    $family: String!
    $after: String
  ) {

    search(
      first: 100
      after: $after
      query: "*"
      types: [PRODUCT]

      productFilters: [
        {
          productMetafield: {
            namespace: "custom"
            key: "ring_family"
            value: $family
          }
        }
      ]
    ) {

      nodes {

        ... on Product {

          id
          handle
          title
          onlineStoreUrl
          availableForSale

          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }

          ringFamily: metafield(
            namespace: "custom"
            key: "ring_family"
          ) {
            value
          }

          ringWidth: metafield(
            namespace: "custom"
            key: "ring_width"
          ) {
            value
          }

          ringMetal: metafield(
            namespace: "custom"
            key: "ring_metal"
          ) {
            value
          }

          ringFinish: metafield(
            namespace: "custom"
            key: "ring_finish"
          ) {
            value
          }

          ringDiamondType: metafield(
            namespace: "custom"
            key: "ring_diamond_type"
          ) {
            value
          }

        }

      }

      pageInfo {
        hasNextPage
        endCursor
      }

    }

  }
`;
  async function apiRequest(
    picker,
    variables
  ) {

    const domain =
      clean(picker.dataset.storeDomain);

    const apiVersion =
      clean(picker.dataset.apiVersion) ||
      '2026-07';

    const token =
      clean(picker.dataset.storefrontToken);


    if (!domain) {

      throw new Error(
        'Shopify store domain is missing.'
      );

    }


    if (
      !token ||
      token ===
      'PASTE_PUBLIC_STOREFRONT_TOKEN_HERE'
    ) {

      throw new Error(
        'Public Storefront API token is missing.'
      );

    }


    const endpoint =
      'https://' +
      domain +
      '/api/' +
      apiVersion +
      '/graphql.json';


    const response =
      await fetch(endpoint, {

        method: 'POST',

        headers: {

          'Content-Type':
            'application/json',

          'X-Shopify-Storefront-Access-Token':
            token

        },

        body:
          JSON.stringify({

            query:
              FAMILY_QUERY,

            variables:
              variables

          })

      });


    if (!response.ok) {

      throw new Error(
        'Storefront API request failed: ' +
        response.status
      );

    }


    const result =
      await response.json();


    if (result.errors?.length) {

      console.error(
        'RCMJ GraphQL errors:',
        result.errors
      );


      throw new Error(
        result.errors
          .map(function (error) {
            return error.message;
          })
          .join(' | ')
      );

    }


    return result.data;

  }


  async function getFamilyProducts(
    picker,
    family
  ) {

    const cacheKey =
      family.toLowerCase();


    if (CACHE.has(cacheKey)) {

      return CACHE.get(
        cacheKey
      );

    }


    let after = null;

    let hasNextPage = true;

    let products = [];


    while (hasNextPage) {

      const data =
        await apiRequest(
          picker,
          {
            family: family,
            after: after
          }
        );


      const search =
        data?.search;


      if (!search) {
        break;
      }


      products =
        products.concat(

          search.nodes
            .filter(Boolean)
            .map(normaliseProduct)

        );


      hasNextPage =
        search.pageInfo?.hasNextPage === true;


      after =
        search.pageInfo?.endCursor || null;


      if (products.length >= 500) {
        hasNextPage = false;
      }

    }


    /*
     * Keep only exact Ring Family matches,
     * but ignore capitalisation / accidental
     * spaces when comparing them.
     */

    products =
      products.filter(function (product) {

        return compare(
          product.family,
          family
        );

      });


    /*
     * Debug information.
     *
     * Leave this in for now.
     * It is very useful while we are testing.
     */

    console.group(
      'RCMJ Ring Family: ' + family
    );

    console.table(

      products.map(function (product) {

        return {

          title:
            product.title,

          width:
            product.width,

          metal:
            product.metal,

          finish:
            product.finish,

          diamond:
            product.diamondType,

          handle:
            product.handle

        };

      })

    );

    console.groupEnd();


    CACHE.set(
      cacheKey,
      products
    );


    return products;

  }


  /* =========================================================
     OPTION VALUES
     ========================================================= */

  function getValuesForDimension(
    products,
    dimension
  ) {

    /*
     * THIS IS THE IMPORTANT CHANGE.
     *
     * We take every actual non-blank value
     * from the entire Ring Family.
     *
     * We do NOT filter using current Width,
     * Metal, Finish or Diamond Type.
     */

    let values =
      unique(

        products.map(function (product) {

          return product[dimension];

        })

      );


    if (dimension === 'width') {

      values =
        sortWidths(values);

    }


    if (dimension === 'metal') {

      values =
        sortMetals(values);

    }


    if (dimension === 'finish') {

      values =
        sortFinishes(values);

    }


    if (dimension === 'diamondType') {

      values =
        sortDiamondTypes(values);

    }


    return values;

  }


  /* =========================================================
     PRODUCT MATCHING
     ========================================================= */

function findExactProduct(
  products,
  desired
) {

  return products.find(
    function (product) {

      return (

        compareDimension(
          'width',
          product.width,
          desired.width
        ) &&

        compareDimension(
          'metal',
          product.metal,
          desired.metal
        ) &&

        compareDimension(
          'finish',
          product.finish,
          desired.finish
        ) &&

        compareDimension(
          'diamondType',
          product.diamondType,
          desired.diamondType
        )

      );

    }
  );

}


  function getTargetProduct(
    products,
    current,
    dimension,
    newValue
  ) {

    const desired = {
      ...current,
      [dimension]:
        newValue
    };


    /*
     * First preference:
     * exact combination.
     */

    const exact =
      findExactProduct(
        products,
        desired
      );


    if (exact) {

      return exact;

    }


    /*
     * If no exact combination exists,
     * find every real product with the
     * newly selected value.
     */

    const candidates =
      products.filter(
        function (product) {

return compareDimension(
  dimension,
  product[dimension],
  newValue
);

        }
      );


    if (!candidates.length) {

      return null;

    }


    /*
     * Score each real candidate.
     *
     * Width and Metal are the most
     * important things to preserve.
     *
     * Finish and Diamond follow.
     */

    const scored =
      candidates.map(
        function (product) {

          let score = 0;


          if (
            dimension !== 'width' &&
            current.width &&
            compareDimension(
  'width',
  product.width,
  current.width
)
          ) {

            score += 100;

          }


          if (
            dimension !== 'metal' &&
            current.metal &&
            compare(
              product.metal,
              current.metal
            )
          ) {

            score += 100;

          }


          if (
            dimension !== 'finish' &&
            current.finish &&
            compare(
              product.finish,
              current.finish
            )
          ) {

            score += 40;

          }


          if (
            dimension !== 'diamondType' &&
            current.diamondType &&
            compare(
              product.diamondType,
              current.diamondType
            )
          ) {

            score += 40;

          }


          /*
           * Prefer available products.
           */

          if (product.available) {

            score += 5;

          }


          return {

            product:
              product,

            score:
              score

          };

        }
      );


    scored.sort(
      function (a, b) {

        return b.score -
               a.score;

      }
    );


    return scored[0].product;

  }


  /* =========================================================
     METAL DISPLAY
     ========================================================= */

  function metalClass(metal) {

    const value =
      metal.toLowerCase();


    if (
      value.includes('yellow')
    ) {

      return 'rcmj-metal-yellow';

    }


    if (
      value.includes('rose')
    ) {

      return 'rcmj-metal-rose';

    }


    if (
      value.includes('white') ||
      value.includes('platinum')
    ) {

      return 'rcmj-metal-white';

    }


    return 'rcmj-metal-default';

  }


  function metalLabel(metal) {

    const value =
      metal.toLowerCase();


    if (
      value.includes('platinum')
    ) {

      return 'P';

    }


    const carat =
      metal.match(
        /\b(9ct|10ct|14ct|18ct|22ct)\b/i
      );


    if (carat) {

      return carat[1];

    }


    return metal;

  }


  /* =========================================================
     ELEMENT CREATION
     ========================================================= */

  function createTextChoice(
    value,
    active,
    targetProduct
  ) {

    const element =
      active
        ? document.createElement('span')
        : document.createElement('a');


    element.className =
      'rcmj-ring-choice' +
      (
        active
          ? ' is-active'
          : ''
      );


    element.textContent =
      value;


    if (active) {

      element.setAttribute(
        'aria-current',
        'true'
      );

    } else {

      element.href =
        targetProduct.url;

    }


    return element;

  }


  function createMetalChoice(
    value,
    active,
    targetProduct
  ) {

    const element =
      active
        ? document.createElement('span')
        : document.createElement('a');


    element.className =
      [
        'rcmj-metal-choice',
        metalClass(value),
        active
          ? 'is-active'
          : ''
      ]
        .filter(Boolean)
        .join(' ');


    element.textContent =
      metalLabel(value);


    element.title =
      value;


    element.setAttribute(
      'aria-label',
      value
    );


    if (active) {

      element.setAttribute(
        'aria-current',
        'true'
      );

    } else {

      element.href =
        targetProduct.url;

    }


    return element;

  }

/* =========================================================
   HOVER PRICE PREVIEW
   ========================================================= */

function formatMoney(
  amount,
  currencyCode
) {

  return new Intl.NumberFormat(
    'en-AU',
    {
      style: 'currency',
      currency:
        currencyCode || 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  ).format(
    Number(amount || 0)
  );

}


function getPriceDifference(
  currentProduct,
  targetProduct
) {

  if (
    !currentProduct ||
    !targetProduct
  ) {

    return '';

  }


  const currentPrice =
    Number(currentProduct.price);

  const targetPrice =
    Number(targetProduct.price);


  if (
    !Number.isFinite(currentPrice) ||
    !Number.isFinite(targetPrice)
  ) {

    return '';

  }


  const difference =
    targetPrice - currentPrice;


  if (
    Math.abs(difference) < 0.01
  ) {

    return '';

  }


  return (
    difference > 0 ? '+' : '-'
  ) +
  formatMoney(
    Math.abs(difference),
    targetProduct.currencyCode ||
    currentProduct.currencyCode
  );

}


function getDimensionLabel(
  dimension
) {

  const labels = {

    width:
      'Band Width',

    metal:
      'Metal Type',

    finish:
      'Finish',

    diamondType:
      'Diamond Origin'

  };


  return labels[dimension] ||
         dimension;

}


function setOptionHeading(
  heading,
  dimension,
  value,
  priceDifference
) {

  if (!heading) return;


  heading.innerHTML = '';


  const label =
    document.createElement(
      'span'
    );


  label.textContent =
    getDimensionLabel(
      dimension
    ) + ': ';


  const selectedValue =
    document.createElement(
      'span'
    );


  selectedValue.className =
    'rcmj-option-heading-value';


  selectedValue.textContent =
    value +
    (
      priceDifference
        ? ' (' +
          priceDifference +
          ')'
        : ''
    );


  heading.appendChild(
    label
  );

  heading.appendChild(
    selectedValue
  );

}


function setupHoverPricePreview(
  group,
  element,
  currentProduct,
  targetProduct,
  dimension,
  value,
  current
) {

  const container =
    group.querySelector(
      '[data-rcmj-options="' +
      dimension +
      '"]'
    );


  /*
   * First try the normal heading class.
   * If it isn't there yet, find the heading
   * sitting directly above the options.
   */

  let heading =
    group.querySelector(
      '.rcmj-option-heading'
    );


  if (!heading) {

    heading =
      Array.from(
        group.children
      ).find(
        function (child) {

          return (
            child !== container &&
            !child.hasAttribute(
              'data-rcmj-options'
            )
          );

        }
      );

  }


  if (!heading) {
    return;
  }


  heading.classList.add(
    'rcmj-option-heading'
  );


  /*
   * Keep selected heading correct.
   */

  setOptionHeading(
    heading,
    dimension,
    current[dimension],
    ''
  );


  /*
   * Active option has no comparison.
   */

  if (
    !currentProduct ||
    !targetProduct
  ) {
    return;
  }


  const priceDifference =
    getPriceDifference(
      currentProduct,
      targetProduct
    );


  function showPreview() {

    setOptionHeading(
      heading,
      dimension,
      value,
      priceDifference
    );

  }


  function restoreHeading() {

    setOptionHeading(
      heading,
      dimension,
      current[dimension],
      ''
    );

  }


  element.addEventListener(
    'mouseenter',
    showPreview
  );

  element.addEventListener(
    'mouseleave',
    restoreHeading
  );

  element.addEventListener(
    'focus',
    showPreview
  );

  element.addEventListener(
    'blur',
    restoreHeading
  );

}

  /* =========================================================
     RENDER EACH DIMENSION
     ========================================================= */

  function renderDimension(
    picker,
    products,
    current,
    dimension
  ) {

    const group =
      picker.querySelector(
        '[data-rcmj-group="' +
        dimension +
        '"]'
      );


    const container =
      picker.querySelector(
        '[data-rcmj-options="' +
        dimension +
        '"]'
      );


    if (
      !group ||
      !container
    ) {

      return;

    }


    const values =
      getValuesForDimension(
        products,
        dimension
      );


    /*
     * Nothing in this entire family uses
     * this dimension.
     *
     * Example:
     * Plain ring has no Diamond Type.
     */

    if (!values.length) {

      group.hidden = true;

      return;

    }


container.innerHTML = '';


const currentProduct =
  products.find(
    function (product) {

      return compare(
        product.handle,
        picker.dataset.currentHandle
      );

    }
  ) ||
  findExactProduct(
    products,
    current
  );


const effectiveCurrent =
  currentProduct
    ? {
        width:
          currentProduct.width,

        metal:
          currentProduct.metal,

        finish:
          currentProduct.finish,

        diamondType:
          currentProduct.diamondType
      }
    : current;


values.forEach(
      function (value) {

const active =
  compareDimension(
    dimension,
    effectiveCurrent[dimension],
    value
  );

        let targetProduct =
          null;


        if (!active) {

targetProduct =
  getTargetProduct(
    products,
    effectiveCurrent,
    dimension,
    value
  );


          /*
           * There should normally always
           * be a target because the value
           * came from a real family product.
           */

          if (!targetProduct) {

            return;

          }

        }


        let element;


        if (
          dimension === 'metal'
        ) {

          element =
            createMetalChoice(
              value,
              active,
              targetProduct
            );

        } else {

          element =
            createTextChoice(
              value,
              active,
              targetProduct
            );

        }


container.appendChild(
  element
);


setupHoverPricePreview(
  group,
  element,
  currentProduct,
  targetProduct,
  dimension,
  value,
  effectiveCurrent
);

      }
    );


    if (
      container.children.length
      === 0
    ) {

      group.hidden = true;

      return;

    }


    group.hidden = false;

  }


  /* =========================================================
     INITIALISE PICKER
     ========================================================= */

  async function initialisePicker(
    picker
  ) {

    if (
      picker.dataset.rcmjInitialised
      === 'true'
    ) {

      return;

    }


    picker.dataset.rcmjInitialised =
      'true';


    const status =
      picker.querySelector(
        '[data-rcmj-ring-status]'
      );


    const family =
      clean(
        picker.dataset.ringFamily
      );


    if (!family) {

      if (status) {

        status.hidden = true;

      }

      return;

    }


    const current =
      getCurrentSelection(
        picker
      );


    try {

      const products =
        await getFamilyProducts(
          picker,
          family
        );


      if (!products.length) {

        throw new Error(
          'No products found for Ring Family "' +
          family +
          '".'
        );

      }


      renderDimension(
        picker,
        products,
        current,
        'width'
      );


      renderDimension(
        picker,
        products,
        current,
        'metal'
      );


      renderDimension(
        picker,
        products,
        current,
        'finish'
      );


      renderDimension(
        picker,
        products,
        current,
        'diamondType'
      );


      if (status) {

        status.hidden = true;

      }


      picker.classList.add(
        'is-ready'
      );


    } catch (error) {

      console.error(
        'RCMJ linked ring picker:',
        error
      );


      if (status) {

        status.textContent =
          'Options unavailable';

        status.classList.add(
          'has-error'
        );

      }

    }

  }


  function initialiseAll() {

    document
      .querySelectorAll(
        '[data-rcmj-linked-ring-picker]'
      )
      .forEach(
        initialisePicker
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseAll
    );

  } else {

    initialiseAll();

  }


  document.addEventListener(
    'shopify:section:load',
    initialiseAll
  );

})();